import { render, staticRenderFns } from "./AddStorageItemsModal.vue?vue&type=template&id=8e0566e2&scoped=true"
import script from "./AddStorageItemsModal.vue?vue&type=script&lang=js"
export * from "./AddStorageItemsModal.vue?vue&type=script&lang=js"
import style0 from "./AddStorageItemsModal.vue?vue&type=style&index=0&id=8e0566e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e0566e2",
  null
  
)

export default component.exports